<template>
  <footer class="footer">
    <div class="container-fluid d-flex flex-wrap justify-content-between">
      <div class="copyright d-flex flex-wrap">
        <span v-if="rodape" v-html="rodape"></span>
        <span v-else>
          <span class="footer-copyright">&copy; 2025</span>
          <span class="footer-sep">•</span>
          <span>Conectaa Sistemas</span>
          <span class="footer-sep">–</span>
          <a
            href="https://conectaa.com.br"
            target="_blank"
            rel="noopener"
            class="footer-link"
          >
            conectaa.com.br
          </a>
        </span>
      </div>
    </div>
  </footer>
</template>

<script>
export default {
  data() {
    return {
      rodape: '',
    };
  },
  mounted() {
    const custom = localStorage.getItem("x-personalizacao-cliente");
    if (custom) {
      try {
        const personalizacao = JSON.parse(custom);
        if (personalizacao.rodape) {
          this.rodape = personalizacao.rodape;
        }
      } catch (e) {
        // ignora erro
      }
    }
  },
};
</script>

<style scoped>
.footer {
  padding: 2px 0 0px 0;
  font-size: 13px;
  margin-top: 2px;
  background: transparent;
  border-top: none;
  text-align: center;
}
.copyright {
  align-items: center;
  width: 100%;
  justify-content: start;
  gap: 0px;
  color: var(--color-footer-text);
  font-size: 13px;
}
.footer-copyright {
  opacity: 0.7;
  vertical-align: middle;
  font-size: 13px;
  color: var(--color-footer-text);
}
.footer-link {
  color: var(--color-primary);
  font-size: 13px;
  font-weight: 500;
  text-decoration: underline;
  transition: color 0.2s;
}
.footer-link:hover {
  color: var(--color-primary-hover);
}
.footer-sep {
  margin: 0 4px;
  opacity: 0.4;
  font-size: 13px;
  font-weight: 400;
  user-select: none;
  color: var(--color-footer-text);
}
</style>
